import React from 'react';
import dayjs from 'dayjs';
import s from './s.module.less';
import WeekDay from '../WeekDay';
import { getDateKey } from 'utils/calendar';
import { EScheduledBy, Event } from 'types/calendar';
import { Popover } from 'antd';
import AddAndEditCalendarEvent from '../AddAndEditCalendarEvent'
import { KlarityService, Prospect } from 'types/common';
import { DEFAULT_CALENDAR_COLOR } from 'constants/common';

type Props = {
    weekDaysArray: dayjs.Dayjs[]
    dateEventMap: Record<string, Event[]>
    onEventEdit?: (event: Event) => void,
    onEventAdd?: (start: dayjs.Dayjs, end: dayjs.Dayjs) => void,
    pendingStartTime?: dayjs.Dayjs,
    pendingEndTime?: dayjs.Dayjs,
    timezone?: string,
    onHidePopLayer?: () => void,
    onSuccessAddNew?: () => void,
    allSpecialityData?: KlarityService[],
    tourTipsStep?: number,
    allClients?: Prospect[],
    targetUrlEventId?: string,
};

const Week = (props: Props) => {
    const {
        weekDaysArray, dateEventMap,
        onEventEdit, onEventAdd, pendingStartTime, pendingEndTime, timezone,
        onHidePopLayer, onSuccessAddNew, allSpecialityData,
        tourTipsStep,
        allClients,
        targetUrlEventId
    } = props;
    const timeArray: string[] = ['0 PM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM',
        '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM', '0',
    ];

    const [currentFocusDayStr, setCurrentFocusDayStr] = React.useState<string>();

    const pendingAreaContent = () => {
        return (
            <div className={s.areaWrap}>
                <AddAndEditCalendarEvent
                    onCancel={() => {
                        onHidePopLayer?.();
                    }}
                    onSuccess={() => {
                        onSuccessAddNew?.();
                    }}
                    defaultStart={pendingStartTime}
                    defaultEnd={pendingEndTime}
                    timezone={timezone}
                    isPopLayer
                    allSpecialityData={allSpecialityData}
                />
                <div
                    onClick={() => {
                        onHidePopLayer?.();
                    }}
                    className={s.closeIcon}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 18L18 6M6 6L18 18" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
            </div>
        )
    };

    return (
        <div className={s.wrap}>
            <div className={s.weekBg}>
                <div className={s.mask}></div>
                {timeArray.map((item) => {
                    return (
                        <div className={`${s.rowLine} rowLine`} key={item}>
                            <span className={s.label}>{item}</span>
                            <hr className={s.line} />
                        </div>
                    );
                })}

            </div>
            <div className={s.contentWrap}>
                {weekDaysArray.map((day, i) => {
                    const key = getDateKey(day);
                    let top = 0;
                    let height = 0;
                    let narrowLayout = false;
                    const showPendingArea = pendingStartTime && getDateKey(day) === getDateKey(pendingStartTime);

                    if (showPendingArea) {
                        const startHour = pendingStartTime.hour();
                        const startMin = pendingStartTime.minute();
                        const endHour = pendingEndTime?.hour() || startHour;
                        const endMin = pendingEndTime?.minute() || startMin;

                        top = startHour * 50 + (startMin * 5) / 6 + 104;
                        const bottom = endHour * 50 + (endMin * 5) / 6 + 73;
                        height = 25;
                    }
                    return (
                        <div
                            onClick={() => {
                            }}
                            className={s.weekDay}
                            key={i}
                        >
                            <div
                                onClick={(e) => {
                                    const offsetTop = e.nativeEvent.offsetY - 106;
                                    const targetHour = Math.floor(offsetTop / 50);
                                    const left = offsetTop % 50;
                                    let min = 0;
                                    if (left > 12.5 && left <= 25) {
                                        min = 15;
                                    }
                                    if (left > 25 && left <= 37.5) {
                                        min = 30;
                                    }
                                    if (left > 37.5 && left <= 50) {
                                        min = 45;
                                    }
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    const startTime = day.hour(targetHour).minute(min);
                                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                    let endTime = day.hour(targetHour).minute(min).add(30, 'minute');
                                    if (endTime.isAfter(dayjs(day).endOf('day'))) {
                                        endTime = dayjs(day).endOf('day');
                                    }
                                    onEventAdd && onEventAdd(startTime, endTime);
                                    setCurrentFocusDayStr(undefined);
                                }}
                                className={s.timeCatch}
                            />
                            <WeekDay
                                targetUrlEventId={targetUrlEventId}
                                currentEditEventDayString={currentFocusDayStr}
                                day={day}
                                key={i}
                                inx={i}
                                onEventEdit={onEventEdit}
                                events={dateEventMap[key] || []}
                                timezone={timezone}
                                onDayItemClick={(dayStr) => {
                                    onHidePopLayer?.();
                                    setCurrentFocusDayStr(dayStr);
                                }}
                                onEventUpdate={() => {
                                    onSuccessAddNew?.();
                                }}
                                allSpecialityData={allSpecialityData}
                                allClients={allClients}
                            />
                            {
                                showPendingArea && (
                                    <Popover
                                        open
                                        placement="right"
                                        zIndex={1000}
                                        title={null} content={pendingAreaContent()} arrow={true}>
                                        <div
                                            className={narrowLayout ? `${s.event} ${s.narrowEvent}` : s.event}
                                            style={{
                                                top,
                                                height: `${height}px`,
                                                right: 8,
                                            }}
                                            onClick={() => {

                                            }}
                                        >
                                            <p className={s.title}>
                                                {/* No title */}
                                            </p>
                                        </div>
                                    </Popover>
                                )
                            }
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Week;
